import { objectSpread2 as _objectSpread2, defineProperty as _defineProperty } from '../../../../_virtual/_rollupPluginBabelHelpers.js';
import * as Yup from 'yup';
import { getArrayValidators } from './field-validators/array.js';
import { getNumberValidators } from './field-validators/number.js';
import { getStringValidators } from './field-validators/string.js';

var getValidatorType = function getValidatorType(type) {
  var types = {
    text: 'string',
    email: 'string',
    password: 'string',
    search: 'string',
    textarea: 'string',
    date: 'string',
    radio: 'string',
    select: 'string',
    range: 'number',
    number: 'number',
    "switch": 'array',
    checkbox: 'array'
  };
  return types[type];
};

var getFieldValidators = function getFieldValidators(field) {
  if (!field.validators) {
    return;
  }

  var validatorType = getValidatorType(field.type);

  switch (validatorType) {
    case 'string':
      return getStringValidators(field);

    case 'number':
      return getNumberValidators(field);

    case 'array':
    default:
      return getArrayValidators(field);
  }
};

var getFormValidators = function getFormValidators(fields, formId) {
  return Yup.object(fields.reduce(function (acc, field, index) {
    if (!field.validators) {
      return _objectSpread2({}, acc);
    }

    var validators = getFieldValidators(field);
    return _objectSpread2(_objectSpread2({}, acc), {}, _defineProperty({}, field.name || "".concat(formId, "-field-").concat(index), validators));
  }, {}));
};

export { getFormValidators, getValidatorType };